import {Routes} from '@angular/router';
import {Auth} from '@components/layout/auth/auth';
import {Main} from "@components/layout/main/main";
import {authGuard} from "@core/guards/auth-guard";
import {loginGuard} from "@core/guards/login-guard";
import {redeGuard} from "@core/guards/rede-guard";
import {Login} from "@pages/auth/login/login";
import {NoPermission} from "@pages/auth/no-permission/no-permission";
import {RedirectCallback} from "@pages/auth/redirect-callback/redirect-callback";
import {AddEditNotificacao} from "@pages/notificacoes/add-edit-notificacao/add-edit-notificacao";
import {Notificacoes} from "@pages/notificacoes/notificacoes";
import {AdminPainel} from "@pages/admin/admin-painel/admin-painel";
import {AdminUsuarios} from "@pages/admin/admin-usuarios/admin-usuarios";
import {AdminListas} from "@pages/admin/admin-listas/admin-listas";
import {AdminMetas} from "@pages/admin/admin-metas/admin-metas";
import {MetaBonificacao} from "@pages/meta-bonificacao/meta-bonificacao";
import {VerificarDados} from "@pages/verificar-dados/verificar-dados";
import {BotSei} from "@pages/bot-sei/bot-sei";
import {AbrirNoSisnot} from "@pages/abrir-no-sisnot/abrir-no-sisnot";

export const routes: Routes = [
  {
    path: '',
    // canActivate: [authGuard], // LOCAL: desativado para acesso sem login
    // Sem login (visitante) só de dentro da rede da ARTESP.
    canActivate: [redeGuard],
    component: Main,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'controle-notificacoes',
      },
      {
        path: 'controle-notificacoes',
        component: Notificacoes,
      },
      {
        canActivate: [authGuard],
        path: 'controle-notificacoes/nova-notificacao',
        component: AddEditNotificacao,
        data: {permissions: ['criar_notificacao']}
      },
      {
        canActivate: [authGuard],
        path: 'controle-notificacoes/notificacao/:id',
        component: AddEditNotificacao,
        data: {permissions: ['editar_notificacao']}
      },
      {
        canActivate: [authGuard],
        path: 'admin',
        component: AdminPainel,
        data: {permissions: ['administrar_sisnot']}
      },
      {
        canActivate: [authGuard],
        path: 'admin/usuarios',
        component: AdminUsuarios,
        data: {permissions: ['administrar_sisnot']}
      },
      {
        canActivate: [authGuard],
        path: 'admin/listas',
        component: AdminListas,
        data: {permissions: ['administrar_sisnot']}
      },
      {
        canActivate: [authGuard],
        path: 'admin/metas',
        component: AdminMetas,
        data: {permissions: ['administrar_sisnot']}
      },
      {
        path: 'meta-bonificacao',
        component: MetaBonificacao,
      },
      {
        path: 'verificar-dados',
        component: VerificarDados,
      },
      {
        // Bot SisNot ↔ SEI: confere no SEI em que caixa estão os processos
        canActivate: [authGuard],
        path: 'bot-sei',
        component: BotSei,
        data: {permissions: ['integracao_sei']}
      },
      {
        // "Abrir no SisNot" do SEI (extensão): sem login, entra e volta pra cá
        path: 'abrir-no-sisnot',
        component: AbrirNoSisnot,
      }
    ]
  },
  {
    path: 'auth',
    canActivate: [loginGuard],
    component: Auth,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'login',
      },
      {
        path: 'login',
        component: Login,
      },
      {
        path: 'redirect-callback',
        component: RedirectCallback,
      },
      {
        path: 'no-permission',
        component: NoPermission,
      },
    ],
  },
  {path: '**', redirectTo: '/'},
];
